var map = {
	"./=DashboardPage-tsx_backup24jan23": 368,
	"./AdminDashboardPage": 84,
	"./AdminDashboardPage.tsx": 84,
	"./CandidatePage": 87,
	"./CandidatePage.tsx": 87,
	"./CheckListPage": 96,
	"./CheckListPage.tsx": 96,
	"./CollationResultDetailPage": 97,
	"./CollationResultDetailPage.tsx": 97,
	"./CollationResultPage": 98,
	"./CollationResultPage.tsx": 98,
	"./CollationResultPage.tsx.bak": 639,
	"./DashboardPage": 99,
	"./DashboardPage.tsx": 99,
	"./DashboardPollingPage": 108,
	"./DashboardPollingPage.tsx": 108,
	"./ElectionPage": 109,
	"./ElectionPage.tsx": 109,
	"./ElectionPollingUnitAddResultPage": 128,
	"./ElectionPollingUnitAddResultPage.tsx": 128,
	"./ElectionPollingUnitDetailPage": 129,
	"./ElectionPollingUnitDetailPage.tsx": 129,
	"./ElectionPollingUnitPage": 130,
	"./ElectionPollingUnitPage.tsx": 130,
	"./ElectionPollingUnitResultDetailPage": 131,
	"./ElectionPollingUnitResultDetailPage.tsx": 131,
	"./ElectionPollingUnitResultPage": 132,
	"./ElectionPollingUnitResultPage - Copy": 348,
	"./ElectionPollingUnitResultPage - Copy.tsx": 348,
	"./ElectionPollingUnitResultPage.tsx": 132,
	"./ElectionPositionPage": 133,
	"./ElectionPositionPage.tsx": 133,
	"./FederalConstituencyPage": 134,
	"./FederalConstituencyPage.tsx": 134,
	"./ImportRegionPage": 135,
	"./ImportRegionPage.tsx": 135,
	"./LocalGovernmentAreaPage": 136,
	"./LocalGovernmentAreaPage.tsx": 136,
	"./PartyCheckListPage": 137,
	"./PartyCheckListPage.tsx": 137,
	"./PartyElectionPollingUnitPage": 138,
	"./PartyElectionPollingUnitPage.tsx": 138,
	"./PartyElectionPollingUnitResultPage": 139,
	"./PartyElectionPollingUnitResultPage.tsx": 139,
	"./PartyIncidencePage": 140,
	"./PartyIncidencePage.tsx": 140,
	"./PartyPage": 141,
	"./PartyPage.tsx": 141,
	"./PollingUnitPage": 142,
	"./PollingUnitPage.tsx": 142,
	"./PrivilegePage": 143,
	"./PrivilegePage.tsx": 143,
	"./ProfilePage": 144,
	"./ProfilePage.tsx": 144,
	"./ResultSummaryNewPageBackup - Copy": 349,
	"./ResultSummaryNewPageBackup - Copy.tsx": 349,
	"./ResultSummaryPage": 145,
	"./ResultSummaryPage - Copy": 350,
	"./ResultSummaryPage - Copy.tsx": 350,
	"./ResultSummaryPage.tsx": 145,
	"./ResultSummaryPage_Backup_Nov22": 351,
	"./ResultSummaryPage_Backup_Nov22.tsx": 351,
	"./RolePage": 146,
	"./RolePage.tsx": 146,
	"./SenatorialDistrictPage": 147,
	"./SenatorialDistrictPage.tsx": 147,
	"./StateConstituencyPage": 148,
	"./StateConstituencyPage.tsx": 148,
	"./StatePage": 149,
	"./StatePage.tsx": 149,
	"./SubscriptionPage": 150,
	"./SubscriptionPage.tsx": 150,
	"./SupportPage": 151,
	"./SupportPage.tsx": 151,
	"./UserPage": 152,
	"./UserPage.tsx": 152,
	"./UserPageModel": 352,
	"./UserPageModel.tsx": 352,
	"./UserPollingUnitPage": 153,
	"./UserPollingUnitPage.tsx": 153,
	"./WardPage": 155,
	"./WardPage.tsx": 155,
	"./docs/FormPage": 156,
	"./docs/FormPage.tsx": 156,
	"./docs/ListTablePage": 157,
	"./docs/ListTablePage.tsx": 157
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 367;


//////////////////
// WEBPACK FOOTER
// ./resources/js/components/pages ^\.\/.*$
// module id = 367
// module chunks = 0